<span class="download">
  <mat-icon>download</mat-icon>
  File is downloading...
</span>
